<div class="app-title">
    <h1 class="page-title">&nbsp; {{Title}} </h1>
</div>